import React, {
	useEffect, useState, memo, FC,
} from 'react';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Container } from '../../../../symphony';

import { SlDataService } from '../../services/sl-data.service';
import { SlLoader } from '../../../../shared/public/SlLoader/SlLoader';
import { lePlaygroundContext } from '../../global-constants';

export interface ILoaderProps {
	backgroundColor?: string;
}
export const Loader: FC<ILoaderProps> = memo(({ backgroundColor = 'rgba(0,0,0,0.3)' }) => {
	const { loading$ } = Container.take(lePlaygroundContext.value, SlDataService);
	const [loadingState, setLoadingState] = useState<boolean>(false);

	useEffect(() => {
		const unsubscriber = new Subject<void>();

		loading$.pipe(takeUntil(unsubscriber)).subscribe(setLoadingState);

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	return loadingState ? (
		<div className="loader-wrapper">
			<SlLoader fullScreen backgroundColor={backgroundColor} />
		</div>
	) : null;
});